<template>
 <div>
    <el-button
      type="primary"
      @click="JumpAddMaintenance"
      size="small"
      v-if="plateNo && exitOperationState!==1 && judgePermission('vehicle_maintenance_list_create')"
    >
      新增维保记录
    </el-button>
    <CarMaintenanceList
      :loading="maintenanceLoading"
      :params="{ carId: String(carId) }"
    />
 </div>
</template>
<script>
import CarMaintenanceList from '@/pages/carsService/maintenance/components/carMaintenanceList.vue'

export default {
  components: {
    CarMaintenanceList,
  },
  props: {
    plateNo: {
      type: String,
      default: '',
    },
    exitOperationState: {
      type: [Number, String],
      defaul: 0,
    },
    carId: {
      type: [Number, String],
      defaul: '',
    },
  },
  data() {
    return {
      maintenanceLoading: {
        search: false,
      },
    }
  },
  methods: {
    /* 新增维保 */
    JumpAddMaintenance() {
      this.$router.push({
        path: '/vehicle/maintenance/add',
        query: {
          plateNo: this.plateNo,
        },
      })
    },
  },
}
</script>
